
export interface TutorLibraryItem {
  pk_tutor_library_item_id: number;
  pk_tutor_library_item_key: string;
  name: string;
  duration: string;
  fk_tut_key: string;
  fk_sub_id: number;
  activity_type: number;
  link: string;
  is_deleted: 0 | 1;
  created_on?: string | null;
  updated_on?: string | null;
  deleted_on?: string | null;
  fk_activity_topic_id?: string | null;
  source: string;
  is_hide: 0 | 1;
  description?: string | null;
  coins: number;
  fk_folder_key?:string;
  pk_folder_key: string;
  folder_name: string;
  data_exists?: 0 | 1;
  lastTwoWeekExist?: 0 | 1;
  lastTwoWeekExistDate?: null;
}

export interface MyLibrary {
  subject_id: number;
  subject_name: string;
  TutorLibraryItems: TutorLibraryItem[];
}

export interface LibraryFolder {
  pk_folder_key: string;
  folder_name: string;
  created_by?: string;
  created_on?: string;
  updated_by?: string;
  updated_on?: string;
}

export const ActivityTypeLookup = {
  1: "Video",
  3: "Link",
  4: "Task",
  5: "Worksheet",
  10: "File",
}